import { render, staticRenderFns } from "./MemberLevelMoveModal.vue?vue&type=template&id=5980ff81&"
import script from "./MemberLevelMoveModal.vue?vue&type=script&lang=js&"
export * from "./MemberLevelMoveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports